import * as THREE from "three";
import { gsap, Power4 } from "gsap";
import { ButtonMesh } from "../components/CustomMesh";
import { vDefaultShader, fButtonShader } from '../shaders';
export class Button {
    constructor({ name, assets, textureIds, aspectRatio = 1 }) {
        this.name = name;
        this.assets = assets;
        this.textureIds = textureIds;
        this.aspectRatio = aspectRatio;
        this.material = this.createMaterial();
        // const geom = new THREE.PlaneGeometry(0.05, 0.05);
        const geom = new THREE.PlaneGeometry(0.0625 * this.aspectRatio, 0.0625);
        this.model = new ButtonMesh(geom, this.material);
        this.model.refButton = this;
        this.model.visible = false;
    }
    createMaterial() {
        return new THREE.ShaderMaterial(Object.assign({ uniforms: this.getUniforms(), transparent: true, 
            //blending: THREE.AdditiveBlending,
            depthWrite: false, depthTest: false }, this.getShaders()));
    }
    getUniforms() {
        const { noise, iconCircle, hatchC } = this.assets.textures;
        return Object.assign(Object.assign({}, this.getMap()), { noiseMap: { value: noise }, circleMap: { value: iconCircle }, hatchingScale: { value: 1 }, hatchingMap: { value: hatchC }, mixDiffuse: { value: 0 }, gamma: { value: 3.5 }, whiteLevel: { value: 1 }, blackLevel: { value: 0 }, time: { value: 0 }, hover: { value: 0 }, opacity: { value: 1 } });
    }
    getMap() {
        return {
            map: { value: this.assets.textures[this.textureIds[0]] },
        };
    }
    getShaders() {
        return {
            fragmentShader: fButtonShader,
            vertexShader: vDefaultShader,
        };
    }
    loop(params) {
        this.material.uniforms.time.value = params.time;
    }
    hide() {
        gsap.to(this.material.uniforms.opacity, {
            value: 0,
            duration: 1,
            ease: Power4.easeOut,
            onComplete: () => this.model.visible = false,
        });
    }
    show(delay = 0) {
        this.model.visible = true;
        gsap.killTweensOf(this.material.uniforms.opacity);
        gsap.to(this.material.uniforms.opacity, {
            value: 1,
            duration: 1,
            delay,
            ease: Power4.easeOut,
        });
    }
    mouseOver() {
        gsap.killTweensOf(this.material.uniforms.hover);
        gsap.to(this.material.uniforms.hover, {
            value: 1,
            duration: 2,
            ease: Power4.easeOut,
        });
    }
    mouseOut() {
        gsap.killTweensOf(this.material.uniforms.hover);
        gsap.to(this.material.uniforms.hover, {
            value: 0,
            duration: 1,
            ease: Power4.easeOut,
        });
    }
}
